Shopify.queryParams = {};

function returnShopifySectionId() {
  const gridElem = document.querySelector('.mm-collection-grid');
  const gridSection = gridElem.closest('.shopify-section');
  return gridSection.id;
}
function returnShopifySectionIdShort() {
  return returnShopifySectionId().replace('shopify-section-', '');
}

function refreshCollectionPageWithFilters(url_filters) {
	let currentUrl = '//' + location.host + location.pathname;
	//let newPageString = httpGet(currentUrl + '?' + url_filters);
    let newPageString = httpGet(`${currentUrl}?${url_filters}&section_id=${returnShopifySectionIdShort()}`);
	let newPageEl = document.createElement('DIV');
	newPageEl.innerHTML = newPageString;
    console.log('newPageString', newPageString)

	let newSection = newPageEl.querySelector('.mm-collection-grid');
	let newElemsFiltersInner = newPageEl.querySelectorAll('.filter-group-display__list');
	let activeFilters = newPageEl.querySelectorAll('.active-filters');

	document.querySelector('.mm-collection-grid').innerHTML = newSection.innerHTML;
	newElemsFiltersInner.forEach(function (newElemFiltersInner, index) {
		document.querySelectorAll('.filter-group-display__list').forEach(function (elem, elemIndex) {
			if (index == elemIndex) {
				elem.innerHTML = newElemFiltersInner.innerHTML;
			}
		});
	});

	activeFilters.forEach(function (activeFilter) {
		var newActiveFilters = document.querySelectorAll('.active-filters');
		newActiveFilters.forEach(function (newActiveFilter) {
			newActiveFilter.innerHTML = activeFilter.innerHTML;
		});
	});

	var newNumHeader = newPageEl.querySelector('.mm-num-active-filter');
	var newNumFilter = newPageEl.querySelector('.mm-num-active-filter');
	document.querySelector('.mm-num-active-filter').innerHTML = newNumHeader.innerHTML;
	document.querySelector('.mm-num-active-filter-cta').innerHTML = newNumFilter.innerHTML;

	// Mise à jour de mm-collection-grid-load-more
	const newLoadMoreSection = newPageEl.querySelector('.mm-collection-grid-load-more');
	const currentLoadMoreSection = document.querySelector('.mm-collection-grid-load-more');
	
	if (currentLoadMoreSection && newLoadMoreSection) {
		currentLoadMoreSection.innerHTML = newLoadMoreSection.innerHTML;
	}

	window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
	
	// Réinitialiser l'accessibilité après la mise à jour AJAX
	if (typeof reinitializeFilterAccessibility === 'function') {
		reinitializeFilterAccessibility();
	}
	
	checkForChanges();
}

function httpGet(theUrl) {
	var xmlHttp = null;

	xmlHttp = new XMLHttpRequest();
	xmlHttp.open('GET', theUrl, false);
	xmlHttp.send(null);
	return xmlHttp.responseText;
}

function checkForChanges() {
	var form = document.getElementById('collectionFacetsForm');
	var inputs = form.querySelectorAll('input');

	inputs.forEach(function (input) {
		input.addEventListener('change', function (e) {
            setTimeout(() => {
    			fakeSubmitForm();
            }, "1");
		});
	});
}

document.querySelectorAll('.sort_by').forEach(function(select) {
	select.addEventListener('change', function (e) {
		var value = e.target.value;
		Shopify.queryParams.sort_by = value;
		location.search = new URLSearchParams(Shopify.queryParams).toString();
	});
});

function fakeSubmitForm() {
	let url_filters = $('#collectionFacetsForm').serialize();
	refreshCollectionPageWithFilters(url_filters);
}

window.addEventListener('DOMContentLoaded', (event) => {
	checkForChanges();
	if (window.innerWidth < 900) {
		mmCheckDrawer();
	}
});

if (window.innerWidth < 900) {
	function mmOpenFiltersMobile() {
		var header = document.querySelector('header');
		var wrapperMobile = document.querySelector('.mm-filters-container');
		wrapperMobile.style.top = header.getBoundingClientRect().bottom + 'px';
		wrapperMobile.style.height = 'calc(var(--doc-height) - ' + header.getBoundingClientRect().bottom + 'px)';
		wrapperMobile.classList.add('mm-open');

		document.querySelector('html').classList.add('stop-scrolling');
	}
	function mmCloseFiltersMobile() {
		var wrapperMobile = document.querySelector('.mm-filters-container');
		wrapperMobile.classList.remove('mm-open');

		document.querySelector('html').classList.remove('stop-scrolling');
	}

	function mmCheckDrawer() {
		var currentUrl = document.location.href.indexOf('?open_filters');
		if (currentUrl !== -1) {
			mmOpenFiltersMobile();
		}
	}
}


// Back to top btn
const backToTopBtn = document.getElementById("backToTopButton");

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
	backToTopBtn.style.display = "block";
  } else {
	backToTopBtn.style.display = "none";
  }
}

function topFunction() {
  // Duration of the scroll animation in milliseconds
  const duration = 500;
  const start = document.documentElement.scrollTop || document.body.scrollTop;
  const startTime = performance.now();

  function scrollStep(timestamp) {
	const currentTime = timestamp - startTime;
	const progress = Math.min(currentTime / duration, 1);
	const ease = 0.5 * (1 - Math.cos(Math.PI * progress));

	document.documentElement.scrollTop = document.body.scrollTop = start * (1 - ease);

	if (currentTime < duration) {
	  window.requestAnimationFrame(scrollStep);
	} else {
	  document.documentElement.scrollTop = document.body.scrollTop = 0;
	}
  }

  window.requestAnimationFrame(scrollStep);
}

// Packshot
function mmPackshotCardView() {
	console.log('mmPackshotCardView');
	// Select all .mm-view-packshot-button and add active
	const packshotButtons = document.querySelectorAll('.mm-view-packshot-button');
	packshotButtons.forEach(button => {
		button.classList.add('mm-active');
	});

	// Select all .mm-view-wear-button and remove active
	const wearButtons = document.querySelectorAll('.mm-view-wear-button');
	wearButtons.forEach(button => {
		button.classList.remove('mm-active');
	});

	// Selectionner toutes les .mm-product-card qui ont un packshot et ajouter la class .mm-product-card-packshot
	const productCards = document.querySelectorAll('.mm-product-card[data-has-packshot="true"]');
	
	productCards.forEach(card => {
		card.classList.add('mm-product-card-packshot');
		
		// En mobile, remplacer la première image du slider par l'image packshot si elle existe
		if (window.innerWidth <= 768) {
			const slider = card.querySelector('.mm-pc-slider');
			
			if (slider) {
				const packshotImage = card.querySelector('.mm-pc-image-packshot');
				const allSliderImages = slider.querySelectorAll('.mm-pc-slider-image');
				
				if (packshotImage && allSliderImages.length > 0) {
					// Cacher toutes les images du slider
					allSliderImages.forEach(img => {
						img.style.opacity = '0';
					});
					
					// Créer une copie de l'image packshot pour mobile si elle n'existe pas déjà
					let mobilePackshotImage = slider.querySelector('.mm-pc-slider-image-packshot-mobile');
					if (!mobilePackshotImage) {
						mobilePackshotImage = packshotImage.cloneNode(true);
						mobilePackshotImage.classList.remove('mm-pc-image-1', 'mm-pc-image-hide-mobile', 'mm-pc-image-packshot');
						mobilePackshotImage.classList.add('mm-pc-slider-image', 'mm-pc-slider-image-packshot-mobile');
						// Insérer l'image packshot au début du lien (premier enfant du slider)
						const linkElement = slider.querySelector('.mm-pc-slides');
						if (linkElement) {
							linkElement.insertBefore(mobilePackshotImage, linkElement.firstChild);
						}
					}
					
					// Afficher l'image packshot mobile
					mobilePackshotImage.style.opacity = '1';
				}
			}
		}
	});
}

function mmWearCardView() {
	console.log('mmWearCardView');
	// Select all .mm-view-wear-button and add active
	const wearButtons = document.querySelectorAll('.mm-view-wear-button');
	wearButtons.forEach(button => {
		button.classList.add('mm-active');
	});

	// Select all .mm-view-packshot-button and remove active
	const packshotButtons = document.querySelectorAll('.mm-view-packshot-button');
	packshotButtons.forEach(button => {
		button.classList.remove('mm-active');
	});

	// Selectionner toutes les .mm-product-card qui ont un packshot et supprimer la class .mm-product-card-packshot
	const productCards = document.querySelectorAll('.mm-product-card[data-has-packshot="true"]');
	productCards.forEach(card => {
		card.classList.remove('mm-product-card-packshot');
		
		// En mobile, restaurer l'affichage normal des images du slider
		if (window.innerWidth <= 768) {
			const slider = card.querySelector('.mm-pc-slider');
			if (slider) {
				// Supprimer l'image packshot mobile du slider
				const mobilePackshotImage = slider.querySelector('.mm-pc-slider-image-packshot-mobile');
				if (mobilePackshotImage) {
					mobilePackshotImage.remove();
				}
				
				// Restaurer l'état de base du slider: afficher uniquement la première image
				const allSliderImages = slider.querySelectorAll('.mm-pc-slider-image');
				allSliderImages.forEach(img => {
					img.style.opacity = '0';
				});
				// Préférer l'image marquée comme première si elle existe, sinon prendre la première du DOM
				let firstImage = slider.querySelector('.mm-pc-image-1.mm-pc-slider-image');
				if (!firstImage) {
					firstImage = allSliderImages[0];
				}
				if (firstImage) {
					firstImage.style.opacity = '1';
				}
			}
		}
	});
}

// Fonction pour gérer le changement de taille d'écran pour les images packshot
function handlePackshotViewOnResize() {
	const isMobile = window.innerWidth <= 768;
	const packshotCards = document.querySelectorAll('.mm-product-card-packshot');
	
	packshotCards.forEach(card => {
		const slider = card.querySelector('.mm-pc-slider');
		if (!slider) return;
		
		const packshotImage = card.querySelector('.mm-pc-image-packshot');
		const mobilePackshotImage = slider.querySelector('.mm-pc-slider-image-packshot-mobile');
		const allSliderImages = slider.querySelectorAll('.mm-pc-slider-image:not(.mm-pc-slider-image-packshot-mobile)');
		
		if (isMobile && packshotImage && allSliderImages.length > 0) {
			// Mode mobile avec packshot
			if (!mobilePackshotImage) {
				// Créer l'image packshot mobile si elle n'existe pas
				const newMobilePackshotImage = packshotImage.cloneNode(true);
				newMobilePackshotImage.classList.remove('mm-pc-image-1', 'mm-pc-image-hide-mobile', 'mm-pc-image-packshot');
				newMobilePackshotImage.classList.add('mm-pc-slider-image', 'mm-pc-slider-image-packshot-mobile');
				// Insérer l'image packshot au début du lien (premier enfant du slider)
				const linkElement = slider.querySelector('.mm-pc-slides');
				if (linkElement) {
					linkElement.insertBefore(newMobilePackshotImage, linkElement.firstChild);
				}
			}
			
			// Cacher toutes les images du slider et afficher l'image packshot
			allSliderImages.forEach(img => {
				img.style.opacity = '0';
			});
			
			if (mobilePackshotImage) {
				mobilePackshotImage.style.opacity = '1';
			}
		} else {
			// Mode desktop ou pas de packshot
			if (mobilePackshotImage) {
				mobilePackshotImage.remove();
			}
			
			// Restaurer toutes les images du slider
			allSliderImages.forEach(img => {
				img.style.opacity = '1';
			});
		}
	});
}

// Ajouter l'écouteur d'événement pour le redimensionnement
window.addEventListener('resize', handlePackshotViewOnResize);

// Fonction d'initialisation pour les images packshot au chargement de la page
function initPackshotView() {
	// Vérifier si on est en mode packshot au chargement
	const packshotButtons = document.querySelectorAll('.mm-view-packshot-button');
	const isPackshotActive = Array.from(packshotButtons).some(button => 
		button.classList.contains('mm-active')
	);
	
	if (isPackshotActive) {
		handlePackshotViewOnResize();
	}
}

// Ajouter l'écouteur d'événement pour l'initialisation
document.addEventListener('DOMContentLoaded', initPackshotView);

// Fonction pour appliquer l'état packshot actuel aux nouveaux produits
function applyCurrentPackshotStateToNewProducts() {
	// Vérifier si on est en mode packshot actuellement
	const packshotButtons = document.querySelectorAll('.mm-view-packshot-button');
	const isPackshotActive = Array.from(packshotButtons).some(button => 
		button.classList.contains('mm-active')
	);
	
	if (isPackshotActive) {
		// Appliquer la vue packshot aux nouveaux produits
		const newProductCards = document.querySelectorAll('.mm-product-card[data-has-packshot="true"]:not(.mm-product-card-packshot)');
		
		newProductCards.forEach(card => {
			card.classList.add('mm-product-card-packshot');
			
			// En mobile, remplacer la première image du slider par l'image packshot si elle existe
			if (window.innerWidth <= 768) {
				const slider = card.querySelector('.mm-pc-slider');
				
				if (slider) {
					const packshotImage = card.querySelector('.mm-pc-image-packshot');
					const allSliderImages = slider.querySelectorAll('.mm-pc-slider-image');
					
					if (packshotImage && allSliderImages.length > 0) {
						// Cacher toutes les images du slider
						allSliderImages.forEach(img => {
							img.style.opacity = '0';
						});
						
						// Créer une copie de l'image packshot pour mobile si elle n'existe pas déjà
						let mobilePackshotImage = slider.querySelector('.mm-pc-slider-image-packshot-mobile');
						if (!mobilePackshotImage) {
							mobilePackshotImage = packshotImage.cloneNode(true);
							mobilePackshotImage.classList.remove('mm-pc-image-1', 'mm-pc-image-hide-mobile', 'mm-pc-image-packshot');
							mobilePackshotImage.classList.add('mm-pc-slider-image', 'mm-pc-slider-image-packshot-mobile');
							// Insérer l'image packshot au début du lien (premier enfant du slider)
							const linkElement = slider.querySelector('.mm-pc-slides');
							if (linkElement) {
								linkElement.insertBefore(mobilePackshotImage, linkElement.firstChild);
							}
						}
						
						// Afficher l'image packshot mobile
						mobilePackshotImage.style.opacity = '1';
					}
				}
			}
		});
	}
}